
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.517 3.317l2.379 4.714 4.579.453a.573.573 0 01.355.977l-3.768 3.735 1.397 5.076a.58.58 0 01-.818.665l-4.643-2.3-4.636 2.297a.578.578 0 01-.818-.665l1.397-5.075-3.772-3.736a.572.572 0 01.356-.977l4.58-.453 2.375-4.711a.582.582 0 011.037 0v0z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    